import React, {useState} from "react";
import SlickSlider from "react-slick";
import slide1 from "../../../assets/images/signup-slides/standups.png";
import slide2 from "../../../assets/images/signup-slides/business.png";
import slide3 from "../../../assets/images/signup-slides/individuals.png";

interface SliderConfigs {
    dots: boolean,
    infinite: boolean,
    speed: number,
    autoplay?: boolean,
    appendDots: (dots: React.ReactNode) => JSX.Element,
    arrows: boolean,
    slidesToShow: number,
    slidesToScroll: number,
}

const sliderData = [
    {
        title: 'Startups',
        desc: 'Having a reliable startup lawyer on your side can provide incredible value to your business.',
        src: slide1
    },
    {
        title: "Businesses",
        desc: "Hire a lawyer who has experience working in your industry and understands its legal environment.",
        src: slide2
    },
    {
        title: "Individuals",
        desc: "Hiring the right lawyer can make a real difference  in the outcome of your case.",
        src: slide3
    }
]


const SignUpSlider = () => {
    const [settings] = useState<SliderConfigs>({
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        arrows: false,
        appendDots: (dots: React.ReactNode): JSX.Element => (<ul className='custom-dots'> {dots} </ul>),
        slidesToShow: 1,
        slidesToScroll: 1
    })

    return (
        <div className="slider-wrapper">
            <SlickSlider className='slider-container' {...settings}>
                {sliderData.map((item, i: number) =>
                    <div key={i} className='slick-slide-item'>
                        <img src={item.src} alt="slide"/>
                        <div className='text-wrapper'>
                            <h1>{item.title}</h1>
                            <p>{item.desc}</p>
                        </div>
                    </div>
                )}
            </SlickSlider>
        </div>
    );
}

export default SignUpSlider;